import { call, all, put, takeLatest, select, delay } from 'redux-saga/effects';

import { saveAs } from 'file-saver';

import notification from '~/services/notification';

import { ISA_ERROR } from '~/constants';
import { GET_ALL_REQUEST, GET_ALL_SELECTS_REQUEST, SHARE_CSV } from './control-notifications-constants';

import * as controlNotificationsActions from './control-notifications-actions';

import { formatDateTime, formatMessage } from '~/i18n/translate';
import controlNotificationsService from './control-notifications-service';
import { AppStateType } from '../root-reducer';

export function* getAll({ payload }: any) {
  try {
    yield put(controlNotificationsActions.setLoadingData(true));
    const { page, rowsPerPage, order, orderBy } = yield select(
      (state: AppStateType) => state.controlNotifications.list
    );

    const filters = {
      userExternalCodes: payload?.vendors?.map((vendor: any) => vendor?.externalCode)?.join(',') ?? []
    };

    const pagination = {
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      orderAsc: order === 'asc' ? 'asc' : 'desc',
      orderBy
    };

    const [{ data: notifications }, { data: count }] = yield all([
      call(controlNotificationsService.getAll, {
        ...pagination,
        ...filters
      }),
      call(controlNotificationsService.getCount, {
        ...filters
      })
    ]);

    yield put(
      controlNotificationsActions.getAllSuccess({
        rows: notifications ?? [],
        rowsCount: count?.count ?? 0
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(controlNotificationsActions.setLoadingData(false));
  }
}

export function* shareCsv({ payload }: any) {
  const toast: any = notification.loading(formatMessage('commonLoadingMessage'));

  try {
    const filters = {
      userExternalCodes: payload?.vendors?.map((vendor: any) => vendor?.externalCode)?.join(',') ?? []
    };

    const { data: csv } = yield call(controlNotificationsService.getCSV, filters);

    const reader = new FileReader();

    const blobFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    reader.readAsDataURL(blobFile);
    reader.onloadend = async function () {
      saveAs(blobFile, `Notificações - ${formatDateTime(new Date())}.csv`);
    };
  } catch (error) {
    yield put(controlNotificationsActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  } finally {
    toast.close();
  }
}

export function* getAllSelects({ payload }: any) {
  yield delay(200);
  try {
    yield put(controlNotificationsActions.setLoadingSelects(true));

    const { roleExternalCode } = yield select((state: AppStateType) => state.auth.user);

    const { data: sellers } = yield call(controlNotificationsService.getSellers, {
      queryString: payload
    });

    yield put(
      controlNotificationsActions.getAllSelectsSuccess({
        selects: {
          vendors: sellers?.filter(seller => seller?.superiorExternalCode === roleExternalCode) ?? []
        }
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
    yield put(controlNotificationsActions.setLoadingSelects(false));
  } finally {
    yield put(controlNotificationsActions.setLoadingSelects(false));
  }
}

export default all([
  takeLatest(GET_ALL_REQUEST, getAll),
  takeLatest(SHARE_CSV, shareCsv),
  takeLatest(GET_ALL_SELECTS_REQUEST, getAllSelects)
]);
